export const getLiveStreamerAdset = {
  request: 'streamer/get_adset_request',
  success: 'streamer/get_adset_success',
  failure: 'streamer/get_adset_failure',
}